// src/hooks/useSlidingPills.js
// 3.39.2: the rows of tabs and filter pills inside the pages (Contacts' All /
// Priority / Not listed, Trash's All / Outbox / Inbox, Console's groups,
// Settings, Users…) get the same coloured highlight as the main menu, sliding
// to the one you pick. Works on every row with role="tablist" (the open one
// is aria-selected) or data-pills (the open one is aria-pressed), so pages
// need no code of their own. The look is in App.jsx (.pill-group, .pill-ind).
import { useEffect } from 'react';

const GROUPS = '[role="tablist"], [data-pills]';
const ACTIVE = ':scope > [aria-selected="true"], :scope > [aria-pressed="true"]';

export default function useSlidingPills() {
  useEffect(() => {
    if (typeof MutationObserver === 'undefined') return undefined;
    const still = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
    let raf = 0;
    const place = g => {
      const on = g.querySelector(ACTIVE);
      let ind = g.querySelector(':scope > .pill-ind');
      if (!on || !on.offsetWidth) {
        if (ind && ind.style.opacity !== '0') { ind.style.opacity = '0'; ind.dataset.box = ''; }
        return;
      }
      if (!g.classList.contains('pill-group')) {
        if (getComputedStyle(g).position === 'static') g.style.position = 'relative';
        g.classList.add('pill-group');
      }
      const first = !ind;
      if (first) {
        ind = document.createElement('span');
        ind.className = 'pill-ind';
        ind.setAttribute('aria-hidden', 'true');
        g.appendChild(ind);
      }
      const box = [on.offsetLeft, on.offsetTop, on.offsetWidth, on.offsetHeight];
      if (ind.dataset.box === box.join()) return;
      // The first time (and when it was hidden) it just appears; after that it slides
      const jump = first || still || !ind.dataset.box;
      ind.dataset.box = box.join();
      if (jump) ind.style.transition = 'none';
      Object.assign(ind.style, { left: `${box[0]}px`, top: `${box[1]}px`, width: `${box[2]}px`, height: `${box[3]}px`,
        borderRadius: getComputedStyle(on).borderRadius, opacity: '1' });
      if (jump) { void ind.offsetWidth; ind.style.transition = ''; }
    };
    const run = () => { raf = 0; document.querySelectorAll(GROUPS).forEach(place); };
    const soon = () => { if (!raf) raf = requestAnimationFrame(run); };
    run();
    const mo = new MutationObserver(soon);
    mo.observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['aria-selected', 'aria-pressed'] });
    window.addEventListener('resize', soon);
    document.fonts?.ready?.then(soon);   // widths settle once the font is in
    return () => { mo.disconnect(); window.removeEventListener('resize', soon); cancelAnimationFrame(raf); };
  }, []);
}
